export const providersUrl = '/compras/proveedores'